<div class="col-md-12">
    <div class="card-box">
      <h4 class="title-f">Account Summary</h4>
      <div class="row" style="padding: 0px 0px 23px 10px;">
        <div class="col-md-4">
          <h5 class="form-lable">Total Contacts:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Account Status:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Broken Promise Indicator:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Broken Promise Counter:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Last Payment Date:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Last Payment Amount:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Last Action Date:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Last Action Code:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Foreclosure:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <div class="col-md-4">
          <h5 class="form-lable">Risk Segment:</h5>
          <input type="text" pInputText placeholder="">
        </div>
        <!-- <div class="col-md-12 mt-20">
              <button type="button" class="btn btn-primary">Add</button>
         </div> -->
    
      </div>
    </div>
  </div>